import { createApp } from 'vue'
import App from './App.vue'
import Home from './Home.vue'
import { createPinia } from 'pinia'
import CKEditor from '@ckeditor/ckeditor5-vue';
import {router} from './routers';
import FastClick from 'fastclick';

FastClick.attach(document.body);

const app = createApp(Home);

app.use(router);

app.use(createPinia()).use(CKEditor).mount('#app');
